//Roadmap Configuration File
//1. dbUrl => URL used to interact with database service
//2. mapBaseUrl => Where are the services stored?
//3. featureProfile => The profile with toggle layers
//4. locationService => Location map service (mapBaseUrl + locationService)

//Development
/*
var roadmapConfig = {
	dbUrl : 'http://csc-s-ims-93-d/Data/Services/Roadmap/getProfiles?f=jsonp&callback=?',
	mapBaseUrl : 'http://csc-s-gis-10-d.coast.noaa.gov/ArcGIS/rest/services/',
	featureProfile : 'Hazard_Profile',
	locationService : 'RoadmapPilot/RoadmapPilotMaps_IndividualLayers/MapServer/',
	basemap : 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/',
	mapThumbs : '125,125', //In Pixels
	mapFull : '900,900',
	shareRoute : 'share'
};
*/

//Production
var roadmapConfig = {
	//dbUrl : '//coast.noaa.gov/dataservices/Roadmap/getProfiles?f=jsonp&callback=?',
	dbUrl : 'model/profiles.json',
	//arcgisonline https://tiles.arcgis.com/tiles/C8EMgrsFcRFL6LrL/arcgis/rest/services/
	mapBaseUrl : '//maps.coast.noaa.gov/arcgis/rest/services/FloodExposureMapper/',//webqa
	noaaBaseUrl: '//maps.coast.noaa.gov/arcgis/rest/services/',//webqa
	//prod
	//mapBaseUrl : 'https://tiles.arcgis.com/tiles/C8EMgrsFcRFL6LrL/arcgis/rest/services/',
	//noaaBaseUrl: '//coast.noaa.gov/arcgis/rest/services/',
	baseMaps : {
			//"street" : "https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/${z}/${y}/${x}",
			"street" : "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/${z}/${y}/${x}",
			"imagery": "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/${z}/${y}/${x}",
			"reference": "https://services.arcgisonline.com/arcgis/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/${z}/${y}/${x}"
	},
	featureProfile : 'Flood_Hazards',
	//locationService : 'http://csc-s-gis-10-d/ArcGIS/rest/services/FloodExposureMapper/AtlanticGulfCoastalCounties/MapServer/',
	locationService : '//maps.coast.noaa.gov/arcgis/rest/services/FloodExposureMapper/AtlanticGulfCoastalCounties/MapServer/',
	basemap : 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/',
	mapThumbs : '125,125', //In Pixels
	mapFull : '900,900',
	shareRoute : 'share',
	maxZoom : 16 //Default is 15

};

